module.exports = __webpack_public_path__ + "chat_128.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/chat_128.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/chat_128.png
// module chunks = 10